<div class="container-fluid">
  <div class="row">
    <div class="col-md-4">
        <div class="row">
            <div class="col-md-12">
                <img class="img-hgt" src="/assets/3 Vehicles Resized.png" alt="iCBMS" style="width: 100%;">

              </div>

        </div>


    </div>


    <div class="col-md-8">
<p class="txt-active">Activating...</p>  
    </div>
  </div>
</div>
<ngx-loading [show]="isLoading"></ngx-loading>
